import { render, staticRenderFns } from "./assign-position-info.vue?vue&type=template&id=4fb54944&scoped=true"
import script from "./assign-position-info.vue?vue&type=script&lang=js"
export * from "./assign-position-info.vue?vue&type=script&lang=js"
import style0 from "./assign-position-info.vue?vue&type=style&index=0&id=4fb54944&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb54944",
  null
  
)

export default component.exports